/**
 * Notification bar
 * --------------------------------------------------
 * Pravilo: kad korisnik klikne na X (zatvori), traka se sakrije
 * i NE prikazuje se ponovo TOG DANA. Sutra se prikazuje ponovo.
 * Ako admin promijeni poruku ili datume, server šalje novi
 * `data-notification-id` pa se traka pokazuje iako je stari ID
 * ranije dismissed.
 */

const STORAGE_KEY = 'beproNotifDismissed';

/**
 * @returns {string} YYYY-MM-DD u korisnikovoj lokalnoj zoni
 */
function todayKey() {
	const d = new Date();
	const m = String(d.getMonth() + 1).padStart(2, '0');
	const day = String(d.getDate()).padStart(2, '0');
	return `${d.getFullYear()}-${m}-${day}`;
}

function readDismissed() {
	try {
		const raw = window.localStorage.getItem(STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		if (!parsed || typeof parsed !== 'object') return null;
		return parsed;
	} catch (e) {
		return null;
	}
}

function writeDismissed(id) {
	try {
		window.localStorage.setItem(
			STORAGE_KEY,
			JSON.stringify({ id, date: todayKey() })
		);
	} catch (e) {
		/* localStorage off / quota — pristajemo na one-shot dismiss bez memorije */
	}
}

function hide(bar) {
	bar.classList.add('notification-bar--hidden');
	bar.setAttribute('aria-hidden', 'true');
}

export default function NotificationBar() {
	const bar = document.querySelector('.js-notification-bar');
	if (!bar) return;

	const id = bar.dataset.notificationId || '';

	// Inicijalna provjera — ako je isti notif već dismissed danas, sakrij odmah.
	const dismissed = readDismissed();
	if (
		dismissed &&
		dismissed.id === id &&
		dismissed.date === todayKey()
	) {
		hide(bar);
		return;
	}

	const closeBtn = bar.querySelector('.js-notification-bar-close');
	if (closeBtn) {
		closeBtn.addEventListener('click', () => {
			writeDismissed(id);
			hide(bar);
		});
	}
}
